<template>
    <div>
        <h1 style="text-align: center;">
<!--            <icon name="calendar" scale="3"></icon>-->
            <img src="../../assets/logo.png" height="200" class="d-inline-block align-top" alt="YMD">
            <br/>Timesheet and Attendance</h1>
        <br/>&nbsp;
        <div class="col-md-12">
            <div class="row justify-content-center " align="center">
                <div v-if="permissionCheck('Employees','Read')" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="check" scale="3"></icon></div>
                    <h4>Attendance</h4>
                    <router-link to="/hr/attendance">Search Timesheets</router-link> <br/>
                </div>
                <div v-if="permissionCheck('Leaves','Read')" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="envelope" scale="3"></icon></div>
                    <h4>Leaves Management</h4>
<!--                    <router-link to="/hr/leaves/list">Leave Applications</router-link> <br/>-->
                    <router-link to="/hr/leaves">Leave Applications</router-link> <br/>
                </div>
                <div v-if="permissionCheck('Shifts','Read')" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="refresh" scale="3"></icon></div>
                    <h4>Shift Management</h4>
                    <router-link to="/hr/shifts">Manage Shifts</router-link> <br/>
                </div>
                <div v-if="permissionCheck('Employees','Read')" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="users" scale="3"></icon></div>
                    <h4>Employees Management</h4>
<!--                    <router-link to="/hr/employees">Employees List</router-link> <br/>-->
                    <router-link to="/hr/employees">Employees List</router-link> <br/>
                </div>
                <div v-if="$store.getters['user/isAdmin']" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="cog" scale="3"></icon></div>
                    <h4>General Management</h4>
                    <!--                    <router-link to="/settings/hr/machines">Punch Machines</router-link> <br/>-->
                    <router-link to="/settings">General Settings</router-link> <br/>
                </div>
                <div v-if="permissionCheck('Shift-Plans','Read')" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="refresh" scale="3"></icon></div>
                    <h4>Shift Plans</h4>
                    <router-link to="/hr/shifts-plans">Manage Shifts Plans</router-link> <br/>
                </div>
                <div v-if="permissionCheck('Machines','Read')" class="col-md-4" style="margin-bottom: 25px;">
                    <div style="margin-bottom: 15px;"><icon name="thumbs-up" scale="3"></icon></div>
                    <h4>Punch Machines</h4>
                    <!--                    <router-link to="/settings/hr/machines">Punch Machines</router-link> <br/>-->
                    <router-link to="/hr/machines">Upload Attendance</router-link> <br/>
                </div>

            </div>
            <br/>
        </div>
    </div>
</template>
<script>
  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
  }
</script>


// WEBPACK FOOTER //
// src/components/hr/dashboard.vue